<template>
  <div class="center">
    <div v-if="annObj[type] == '中标公告'" style="margin-bottom: 20px">
      <el-input
        style="width: 300px; margin: 0 10px 10px 0"
        v-model="searchData.messageContent"
        placeholder="请输入公告标题"
        maxLength="99"
        clearable></el-input>
      <el-date-picker
        style="width: 300px; margin: 0 10px 10px 0"
        @change="pickerChange"
        v-model="timeRange"
        type="daterange"
        range-separator="-"
        value-format="yyyy-MM-dd"
        start-placeholder="中标开始日期"
        end-placeholder="中标结束日期"
        clearable>
      </el-date-picker>
      <el-button @click="searchFn" class="hy-btn">搜索</el-button>
      <el-button @click="resetFn" class="cl-btn">清除</el-button>
    </div>
    <div class="gg_header">{{ annObj[type] }}</div>
    <div
      @click="tobiddingdeatil(item)"
      v-for="(item, i) in biddingList"
      :key="i"
      class="flx_box list_item">
      <!-- <div class="img" v-if="item.messageImg!=''">
        <el-image style="width: 100%; height: 100%" :src="baseUrl + 'third/third/ossGetFile/' + item.messageImg" />
      </div>
      <div class="img" v-else>
    
        <img style="width: 100%; height: 100%" src="../../assets/zxx_img/wuliu.png" alt="">
      </div> -->
      <div class="right">
        <div class="title">{{ item.messageContent }}</div>
        <div class="right_body">
          <div>{{ item.messageContent }}</div>
        </div>
        <div class="right_data">
          <i class="hy-icon-shijian1"></i>
          {{ item.createTime }}
        </div>
      </div>
    </div>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchData.page"
      :limit.sync="searchData.size"
      @pagination="getList" />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // 分页组件
import { biddingList } from "@/api/home";
import { reqBiddingTargeted } from "@/api/public";
import * as types from "@/store/action-types";
import Vue from "vue";
const { baseUrl } = require("@/config");
export default {
  components: { Pagination },
  created() {
    // console.log(t);
    this.type = this.$route.query.type;
    this.getList();
  },
  data() {
    return {
      /** 中标时间范围 */
      timeRange: [],
      annObj: {
        win: "中标公告",
        bidding: "竞价公告",
        biddings: "物流竞价公告",
      },
      searchData: {
        enterpriseId: 0,
        messageType: 0,
        page: 1,
        size: 10,
        /** 公告标题 */
        messageContent: "",
        /**中标开始日期 */
        startDate: "",
        /** 中标结束日期 */
        endDate: "",
      },
      total: 0,
      biddingList: [],
      type: "",
      baseUrl: baseUrl,
    };
  },
  methods: {
    /** 中标日期选择 */
    pickerChange(e) {
      if (e?.length) {
        this.searchData.startDate = e[0] + " 00:00:00";
        this.searchData.endDate = e[1] + " 23:59:59";
      } else {
        this.searchData.startDate = null;
        this.searchData.endDate = null;
      }
    },
    searchFn() {
      this.searchData.pageNum = 1;
      this.getList();
    },
    resetFn() {
      this.searchData.pageNum = 1;
      this.searchData.messageContent = "";
      this.timeRange = [];
      this.searchData.startDate = "";
      this.searchData.endDate = "";
      this.getList();
    },
    /** 跳转公告详情页(定向中标公告先校验登录认证与查看权限) */
    tobiddingdeatil(item) {
      // 中标公告(messageType == 2)先校验是否定向竞价
      if (this.annObj[this.type] == "中标公告" && item.messageType == 2) {
        reqBiddingTargeted(item.businessId).then(res => {
          if (res.code != 0) {
            // 接口异常:展示后端返回信息
            this.$message(res.message);
            return;
          }
          // 未开启定向竞价:公开公告,直接跳转
          if (res.data.biddingTargeted != 1) {
            this.$router.push({
              path: "/biddingdeatil",
              query: {
                type: this.type,
                messageId: item.messageId,
                businessId: item.businessId,
              },
            });
            return;
          }
          // 开启定向竞价:先校验登录与认证
          if (!this.beforhandle("all")) return;
          // 已登录已认证:再看是否为参与方
          if (res.data.partiesFlag == 1) {
            this.$router.push({
              path: "/biddingdeatil",
              query: {
                type: this.type,
                messageId: item.messageId,
                businessId: item.businessId,
              },
            });
          } else {
            // 定向竞价非参与方
            this.$message.error("对不起,您还未获得该场次中标公告的查看权限");
          }
        });
        return;
      }
      // 其他公告直接跳转
      this.$router.push({
        path: "/biddingdeatil",
        query: {
          type: this.type,
          messageId: item.messageId,
          businessId: item.businessId,
        },
      });
    },
    getList() {
      this.searchData.enterpriseId = Vue.ls.get(types.userId) || 0;
      if (this.type == "win") {
        this.searchData.messageType = 2;
      } else if (this.type == "bidding") {
        this.searchData.messageType = 1;
      } else if (this.type == "biddings") {
        this.searchData.messageType = 3;
      }
      biddingList(this.searchData).then(res => {
        console.log(res, "res");
        this.total = res.data.total;
        this.biddingList = res.data.records.map(item => {
          return {
            ...item,
            createTime: item.createTime.replace("T", " "),
            messageImg: item.messageImg,
          };
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list_item {
  padding: 16px;
  height: 137px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
}
.flx_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img {
  width: 145px;
  height: 105px;
  border-radius: 4px;
}
.gg_header {
  height: 47px;
  line-height: 47px;
  padding-left: 12px;
  background: #f3f3f3;
  border: 1px solid #e5e5e5;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.title {
  margin-bottom: 17px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.right_body {
  height: 34px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
.right_data {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.right {
  cursor: pointer;
  width: 986px;
  padding-right: 20px;
}
</style>
